export const HERO = {
    title: "Hi, I'm",
    subtitle: "I'm a",
    name: "Mosabbir Ahamed",
    typeWriter: ["Lead Generation Specialist","Data Scraping Expert", "Email Outreach Specialist"],
    bgImage: "/Asset/hero_bg.jpg",
    button: {
        text: "My Resume",
        url: "https://drive.google.com/file/d/1cnzcDvKnaibUJ3XTHuXOmutfnOlAkAXT/view?usp=sharing"
    }
}
